<template>
  <div id="loading" class="vs-con-loading__container">
    <ul class="nav nav-pills">
      <li class="nav-item mt-1">
        <h4 style="display: flex; align-items: center">
          Building :
          <vs-input
            disabled
            class="ml-2"
            placeholder="Disabled"
            v-model="path_item.name"
          />
        </h4>
      </li>
      <li class="nav-item mt-1 ml-3">
        <h4 style="display: flex; align-items: center">
          Meter :
          <vs-select class="ml-2" @change="goto" v-model="select2">
            <vs-select-item
              :key="index"
              :value="item.device"
              :text="item.name"
              v-for="(item, index) in options4"
            />
          </vs-select>
        </h4>
      </li>
    </ul>
    <br />
    <!-- <pre>{{data}}</pre> -->
    <!-- {{ destinationId }} -->
    <div>
      <divBodyOutLine :item="data" />
    </div>
  </div>
</template>

<script>
import divBodyOutLine from "./PageTwo.vue";
export default {
  components: { divBodyOutLine },
  data() {
    return {
      path_item: {
        name: this.$route.params.building,
        id: this.$route.params.machine,
      },
      select2: this.$route.params.machine,
      data: {
        Electric_Potential: {},
        Electric_Potential_Graph: {},
        Graph_of_Power_Consumption: {},
        Power_Factor: {},
        Power_Volume: {},
        Total_power_consumption: {},
      },
      options4: [
        { text: "PowerMeter01", value: 1 },
        { text: "PowerMeter02", value: 2 },
        { text: "PowerMeter03", value: 3 },
        { text: "PowerMeter04", value: 4 },
        { text: "PowerMeter05", value: 2 },
        { text: "PowerMeter06", value: 3 },
        { text: "PowerMeter07", value: 4 },
      ],
      interval: null,
    };
  },
  async mounted() {
    console.log(this.$route.params);
    // this.data = this.$session.get("data");
    // this.select2 = this.$route.params.id;
    this.$vs.loading({
      type: "default",
      container: "#loading",
    });
    await this.getList();
    await this.getData();
    this.$vs.loading.close("#loading > .con-vs-loading");
    
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    goto() {
      console.log("prueba de focsu", this.select2);

      if (this.$route.path.includes("PublicAjinomoto")) {
        this.$router.push(
          "/PublicAjinomoto/Machinelist/" +
            this.path_item.name +
            "/" +
            this.select2
        );
      } else {
        this.$router.push(
          "/Machinelist/" + this.path_item.name + "/" + this.select2
        );
      }
    },
    async getList() {
      let res = await this.$API.get(
        `ajino-get-building/${this.$route.params.building}`
      );
      console.log(res.data);
      this.options4 = res.data.message;
    },
    async getData() {
      // console.log(this.path_item.name, this.select2);

      let building = this.path_item.name;
      let machine = this.path_item.id;
      console.log(building, machine);
      let res = await this.$API.get(
        `ajino-get-machine/${this.path_item.name}/${this.path_item.id}`
      );
      console.log("ajino-get-machine", res);
      this.data = res.data.message;

      this.interval = setTimeout(() => {
      this.getData();
    }, 15 * 1000);
    },
  },

  computed: {
    rawData() {
      return this.data;
    },
  },
};
</script> 
 
 
 
